import type { ReactElement } from 'react';
import { monthAndYear } from 'utils/dateTimes';

import { Component as NextIcon } from 'icons/icon-ui--arrow-right-outline.svg';
import { Component as PrevIcon } from 'icons/icon-ui--arrow-left-outline.svg';

type Props = {
  hasPreviousOrders: boolean;
  hasNextOrders: boolean;
  currentPeriod: Date;
  navigateTo: (direction: 'next' | 'prev', period: Date) => void;
};

function Header({
  hasPreviousOrders,
  hasNextOrders,
  currentPeriod,
  navigateTo,
}: Props): ReactElement {
  return (
    <div className="c-orders">
      <div className="c-orders-header">
        <h1 className="c-heading c-heading--brand-4">
          Order History
        </h1>
      </div>
      <div className="c-orders-navigation">
        <button
          className="c-orders-navigation__arrow c-link"
          type="button"
          aria-label="Previous month"
          disabled={!hasPreviousOrders}
          onClick={() => navigateTo('prev', currentPeriod)}
        >
          <PrevIcon width={11} height={18} />
        </button>
        <div className="c-orders-navigation__month">
          <p>
            <strong>
              {currentPeriod && monthAndYear(currentPeriod)}
            </strong>
          </p>
        </div>
        <button
          className="c-orders-navigation__arrow c-link"
          type="button"
          aria-label="Next month"
          disabled={!hasNextOrders}
          onClick={() => navigateTo('next', currentPeriod)}
        >
          <NextIcon width={11} height={18} />
        </button>
      </div>
    </div>
  );
}

export default Header;
